import { Link } from 'react-router-dom';

export default function StoryIntro() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Ethereal%20anime%20style%20scene%20of%20a%20girl%20standing%20under%20giant%20ancient%20cherry%20blossom%20tree%20with%20countless%20pink%20petals%20falling%2C%20soft%20diffused%20sunlight%2C%20dreamy%20atmosphere%2C%20Japanese%20garden%20with%20stone%20lanterns%2C%20pastel%20color%20palette%2C%20illustration%20style%20with%20delicate%20details%2C%20warm%20gentle%20composition&width=900&height=675&seq=sakura-story-intro&orientation=landscape"
                alt="樱境物语故事世界"
                title="樱境物语 - 沉浸式叙事体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent"></div>
            </div>
            <div className="absolute -bottom-5 -right-5 w-32 h-32 rounded-2xl overflow-hidden border-4 border-background-50 hidden lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=Delicate%20cherry%20blossom%20branch%20in%20full%20bloom%20against%20soft%20pastel%20sky%2C%20closeup%20of%20pink%20sakura%20petals%20with%20golden%20sunlight%2C%20anime%20illustration%20style%2C%20clean%20simple%20background&width=300&height=300&seq=sakura-story-small&orientation=squarish"
                alt="樱花特写"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div>
            <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-primary-50 text-primary-600 mb-5 whitespace-nowrap">
              关于樱境
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-6 leading-tight">
              千年樱境，<br />
              <span className="text-primary-600">一梦浮生</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-5">
              在遥远的东方，有一片被樱花永恒守护的神秘之地 —— <strong>樱境</strong>。这里四季如春，樱花终年不谢。每一位到访者都将在这片土地上，开启一段独一无二的物语之旅。
            </p>
            <p className="text-foreground-600 leading-relaxed mb-5">
              你将扮演一位意外闯入樱境的旅人，在这片充满魔法与奇迹的土地上，邂逅性格各异的伙伴，揭开樱境千年的秘密。你的每一个选择，都将牵动故事的丝线，编织出只属于你的结局。
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              超过<strong className="text-primary-600">20万字</strong>的原创剧本、<strong className="text-primary-600">30+位</strong>可攻略角色、<strong className="text-primary-600">7种</strong>不同结局 —— 一段关于爱、羁绊与成长的樱花奇旅，正等待着你。
            </p>
            <Link
              to="/category/story"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              探索更多故事
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}